import React from 'react';
import AdminLayout from '../../../Components/CommonComponents/Layout/adminLayout';
import UserContainer from '../../../Containers/AdminContainer/Users';

const UserScreen = () => {
  return <UserContainer />;
};

export default UserScreen;
